import React from 'react'
import { Link, graphql } from 'gatsby'
import Layout from '../components/layout'
import SEO from "../components/seo"
import Bio from "../components/bio"

const ArticlesByYear = ({ pageContext, data }) => {


  const { year } = pageContext
  const { edges, totalCount } = data.allMarkdownRemark
  const yearHeader = `${totalCount} post${
    totalCount === 1 ? '' : 's'
  } from ${year}`
  return (
    <Layout>
      <div className="content-box clearfix">
        <div className="blog-tags">
          <h1>{yearHeader}</h1>
          <ul className="tag-list">
            {edges.map(({ node }) => {
              const { title, date } = node.frontmatter
              const { slug } = node.fields
              return (
                <li key={slug}>
                  <Link to={slug}>{title}</Link>
                  <small> | {date}</small>
                </li>
              )
            })}
          </ul>
        </div>
      </div>
      <Bio useArticles={true} useTags={true}/>
    </Layout>
  )
}

export default ArticlesByYear

export const Head = ({ pageContext, data }) => (
    <SEO
        title={`Articles datant de ${pageContext.year}`}
        keywords={[`gamedev`, `Haxe`, `Unity`, `Lyon`, `studio de développement de jeux`]}
    />
  )

export const pageQuery = graphql`
  query ($year: Date!, $yearEnd: Date!) {
    allMarkdownRemark(
      limit: 2000
      sort: {frontmatter: {date: DESC}}
      filter: { frontmatter: { date: { gte: $year, lt: $yearEnd } } }
    ) {
      totalCount
      edges {
        node {
          fields {
            slug
          }
          frontmatter {
            title
            date(formatString: "MMMM DD, YYYY")
          }
        }
      }
    }
  }
`